<template>
  <!-- start 键盘-->
  <div class="keyboard">
    <div
      :class="[
        item.type == 5 ? 'blank' : '',
        item.type == 4 ? 'shift' : '',
        item.type == 3 ? 'caps-Lock' : '',
        item.type == 2 ? 'enter' : '',
        item.type == 1 ? 'tab' : '',
        item.type == 0 ? 'common-key' : '',
        item.colorType == 1 && item.select == 0 ? 'color-type-one' : '',
        item.colorType == 2 && item.select == 0 ? 'color-type-two' : '',
        item.colorType == 3 && item.select == 0 ? 'color-type-three ' : '',
        item.select == 1 ? 'correct-view' : '',
        item.select == 2 && item.type != 2 ? 'mistake' : '',
      ]"
      v-for="(item, key) in KeypadList"
      :key="key"
      :style="
        key != 14 && key != 28 && key != 53 && key != 61
          ? 'margin-right:6px;'
          : ''
      "
    >
      <template v-if="item.type == 2">
        <div
          class="enter-view"
          :class="[
            item.select == 1 ? 'correct-view' : '',
            item.select == 2 ? 'mistake' : '',
          ]"
        >
          <div class="interior-vessel">
            <span v-if="item.select != 2" style="margin-top: 55px">Enter</span>
            <span
              v-if="item.select == 2"
              style="margin-top: 55px"
              class="mistake-icon"
              >X</span
            >
          </div>
          <div
            class="left-view"
            :class="[
              item.select == 1 ? 'correct-view' : '',
              item.select == 2 ? 'mistake' : '',
            ]"
          >
            <div class="left-view-interior-vessel"></div>
          </div>
        </div>
      </template>
      <template v-if="key == 41">
        <div class="placeholder-view"></div>
      </template>
      <template
        v-if="item.distribute == 0 && item.type != 2 && item.select != 2"
      >
        <div class="interior-key separate-align">
          <div>{{ item.valOne }}</div>
          <div>{{ item.valTow }}</div>
        </div>
      </template>
      <template v-if="item.distribute == 1 && item.select != 2">
        <div class="interior-key below-align">
          <div>{{ item.valOne }}</div>
        </div>
      </template>
      <template v-if="item.distribute == 2 && item.select != 2">
        <div
          class="interior-key"
          :class="
            item.type == 1 || item.type == 3 ? 'special-align' : 'center-align'
          "
        >
          <div>{{ item.valOne }}</div>
        </div>
      </template>
      <template v-if="item.select == 2">
        <div class="interior-key center-align">
          <div class="mistake-icon">X</div>
        </div>
      </template>
    </div>
  </div>
  <!-- end 键盘 -->
</template>

<script>
export default {
  name: "Keyboard",
  data() {
    return {
      KeypadList: [
        {
          valOne: "~",
          valTow: "`",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0, //0:默认，1：正确，2：错误
          code: 'Backquote'
        },
        {
          valOne: "!",
          valTow: "1",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Digit1'
        },
        {
          valOne: "@",
          valTow: "2",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit2'
        },
        {
          valOne: "#",
          valTow: "3",
          distribute: 0,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'Digit3'
        },
        {
          valOne: "$",
          valTow: "4",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit4'
        },
        {
          valOne: "%",
          valTow: "5",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit5'
        },
        {
          valOne: "^",
          valTow: "6",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit6'
        },
        {
          valOne: "&",
          valTow: "7",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit7'
        },
        {
          valOne: "*",
          valTow: "8",
          distribute: 0,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'Digit8'
        },
        {
          valOne: "(",
          valTow: "9",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Digit9'
        },
        {
          valOne: ")",
          valTow: "0",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Digit0'
        },
        {
          valOne: "-",
          valTow: "",
          distribute: 1,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Minus'
        },
        {
          valOne: "=",
          valTow: "",
          distribute: 1,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Equal'
        },
        {
          valOne: "|",
          valTow: "\\",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Backslash'
        },
        {
          valOne: "Back",
          valTow: "space",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Backspace'
        },
        {
          valOne: "Tab",
          valTow: "",
          distribute: 2,
          type: 1,
          colorType: 1,
          select: 0,
          code: 'Tab'
        },
        {
          valOne: "Q",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'KeyQ'
        },
        {
          valOne: "W",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyW'
        },
        {
          valOne: "E",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'KeyE'
        },
        {
          valOne: "R",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyR'
        },
        {
          valOne: "T",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyT'
        },
        {
          valOne: "Y",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyY'
        },
        {
          valOne: "U",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyU'
        },
        {
          valOne: "I",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'KeyI'
        },
        {
          valOne: "O",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyO'
        },
        {
          valOne: "P",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'KeyP'
        },
        {
          valOne: "{",
          valTow: "[",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'BracketLeft'
        },
        {
          valOne: "}",
          valTow: "]",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'BracketRight'
        },
        {
          valOne: "Enter",
          valTow: "",
          distribute: 0,
          type: 2,
          colorType: 1,
          select: 0,
          code: 'Enter'
        },
        {
          valOne: "Caps Lock",
          valTow: "",
          distribute: 2,
          type: 3,
          colorType: 1,
          select: 0,
          code: 'CapsLock'
        },
        {
          valOne: "A",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'KeyA'
        },
        {
          valOne: "S",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyS'
        },
        {
          valOne: "D",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'KeyD'
        },
        {
          valOne: "F",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyF'
        },
        {
          valOne: "G",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyG'
        },
        {
          valOne: "H",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyH'
        },
        {
          valOne: "J",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyJ'
        },
        {
          valOne: "K",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'KeyK'
        },
        {
          valOne: "L",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyL'
        },
        {
          valOne: ":",
          valTow: ";",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Semicolon'
        },
        {
          valOne: '"',
          valTow: "'",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Quote'
        },
        {},
        {
          valOne: "Shift",
          valTow: "",
          distribute: 2,
          type: 4,
          colorType: 1,
          select: 0,
          code: 'ShiftLeft'
        },
        {
          valOne: "Z",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'KeyZ'
        },
        {
          valOne: "X",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyX'
        },
        {
          valOne: "C",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'KeyC'
        },
        {
          valOne: "V",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyV'
        },
        {
          valOne: "B",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyB'
        },
        {
          valOne: "N",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyN'
        },
        {
          valOne: "M",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'KeyM'
        },
        {
          valOne: "<",
          valTow: ",",
          distribute: 0,
          type: 0,
          colorType: 3,
          select: 0,
          code: 'Comma'
        },
        {
          valOne: ">",
          valTow: ".",
          distribute: 0,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'Period'
        },
        {
          valOne: "?",
          valTow: "/",
          distribute: 0,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'Slash'
        },
        {
          valOne: "Shift",
          valTow: "",
          distribute: 2,
          type: 4,
          colorType: 1,
          select: 0,
          code: 'ShiftRight'
        },
        {
          valOne: "Ctrl",
          valTow: "",
          distribute: 2,
          type: 1,
          colorType: 1,
          select: 0,
          code: 'ControlLeft'
        },
        {
          valOne: "Win",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'MetaLeft'
        },
        {
          valOne: "Alt",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'AltLeft'
        },
        {
          valOne: " ",
          valTow: " ",
          distribute: 2,
          type: 5,
          colorType: 2,
          select: 0,
          code: 'Space'
        },
        {
          valOne: "Alt",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 2,
          select: 0,
          code: 'AltRight'
        },
        {
          valOne: "Win",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: ''
        },
        {
          valOne: "书本",
          valTow: "",
          distribute: 2,
          type: 0,
          colorType: 1,
          select: 0,
          code: 'ContextMenu'
        },
        {
          valOne: "Ctrl",
          valTow: "",
          distribute: 2,
          type: 1,
          colorType: 1,
          select: 0,
          code: 'ControlRight'
        },
      ],
      keyStr: null,
      keyVal: null,
    };
  },
  props: {
    code: { //键盘输入键值
      typeof: String,
      default: null
    },
    isCorrect: { //正确值
      typeof: Boolean,
      default: false
    }
  },
  created() {
    //this.keydown();
  },
  watch: {
    code:{
      handler(newStr){
        this.initializeKeyValue();
        this.KeypadList.forEach((item,key) => {
          if(item.code == newStr && newStr != null && newStr != 'Backspace' && newStr != 'Tab' && newStr != 'ShiftLeft'){
            this.isCorrect?this.KeypadList[key].select=1:this.KeypadList[key].select=2;
          }
        })
       },
    }
  },
  methods: {
     // 初始化
    initializeKeyValue() {
      this.KeypadList.forEach((item, key) => {
        if(item.select != undefined){
          this.KeypadList[key].select = 0;
        }
      })
    },
    // 预键入值
    beforehandToType(code) {
      console.log(code)
    },
    // 正确值，预键入值
    typeTheValue() {

    }
  },
};
</script>

<style scoped lang="scss">
.keyboard {
  width: 898px;
  background: #e1e0e7;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d3d2db;
  padding: 5px 8px;
  box-sizing: border-box;

  display: flex;
  flex-flow: wrap;
  .common-key {
    width: 53px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 4px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .interior-key {
    //width: 43px;
    //height: 44px;
    height: 44px;
    //background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
    //box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
    display: flex;
    //justify-content: center;
  }
  .tab {
    width: 79px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .shift {
    width: 140px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .blank {
    width: 410px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .enter {
    width: 86px;
    height: 55px;
    // background: #c3acd2;
    // border-radius: 3px 3px 3px 3px;
    // border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // padding: 5px;
    // box-sizing: border-box;
    // font-size: 16px;
    // font-weight: 800;
    // color: #000000;
    // margin-bottom: 3px;
  }
  .caps-Lock {
    width: 112px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .separate-align {
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;
  }
  .center-align {
    align-items: center;
    justify-content: center;
  }
  .special-align {
    text-align: left;
    align-items: center;
    padding-left: 12px;
  }
  .below-align {
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
  }

  .enter-view {
    width: 86px;
    height: 112px;
    background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    padding: 5px;
    box-sizing: border-box;
    position: relative;
    .interior-vessel {
      height: 100%;
      background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
      box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
      display: flex;
      justify-content: center;
    }
    .left-view {
      position: absolute;
      width: 28px;
      height: 52px;
      background: #c3acd2;
      bottom: -1px;
      left: -26px;
      border-top: 1px solid #482762;
      border-left: 1px solid #482762;
      border-bottom: 1px solid #482762;
      padding: 3px 0 3px 5px;
      box-sizing: border-box;
      .left-view-interior-vessel {
        width: 30px;
        height: 100%;
        background: linear-gradient(180deg, #d5c5e4 0%, #c9b4dc 100%);
        //box-shadow: 0px 3px 6px 0px rgba(131, 62, 180, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
        border-right: none;
        box-sizing: border-box;
      }
    }
  }
  .placeholder-view {
    width: 100px;
    height: 55px;
  }

  .color-type-one {
    background: #c3acd2;
    .interior-key {
      background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
      box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
    }
  }
  .color-type-two {
    background: #b4c3df;
    .interior-key {
      box-shadow: 0px 3px 6px 1px rgba(82, 107, 153, 0.4);
      background: linear-gradient(180deg, #dce1f0 0%, #b0bbdd 100%);
    }
  }
  .color-type-three {
    background: #bdd7ba;
    .interior-key {
      box-shadow: 0px 3px 6px 1px rgba(48, 92, 40, 0.4);
      background: linear-gradient(180deg, #dfecdf 0%, #b9d4bd 100%);
    }
  }
  .correct-view {
    background: linear-gradient(180deg, #79ffff 0%, #46c4ff 100%) !important;

    border-radius: 3px 3px 3px 3px;
    .interior-key {
      border: 1px solid #ffffff;
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4);
      background: linear-gradient(180deg, #bfffff 0%, #51c8ff 100%);
    }

    .interior-vessel {
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4) !important;
      background: linear-gradient(180deg, #bfffff 0%, #51c8ff 100%) !important;
    }

    .left-view-interior-vessel {
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4) !important;
      background: linear-gradient(
        180deg,
        rgb(128, 225, 255) 0%,
        #51c8ff 100%
      ) !important;
    }
  }

  .mistake {
    //border: 1px solid #585858;
    border-radius: 3px 3px 3px 3px;
    background: #ffbd5d !important;
    .interior-key {
      border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4);
      background: linear-gradient(180deg, #ffdec6 0%, #ffc168 100%);
    }

    .interior-vessel {
      background: linear-gradient(180deg, #ffdec6 0%, #ffc168 100%) !important;
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4) !important;
    }

    .left-view-interior-vessel {
      background: linear-gradient(
        180deg,
        rgb(255, 205, 144) 0%,
        #ffc168 100%
      ) !important;
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4) !important;
    }
  }

  .mistake-icon {
    color: red;
    font-weight: 900;
    font-size: 26px;
  }
}
</style>
